import { useContext, useEffect } from "react";
import { ILoaderCategory, loaderContext } from "../contexts/LoaderContext";

export const useLoader = (
  isCategoryLoadig: boolean,
  category: ILoaderCategory
) => {
  const { isLoading, handleSetLoading, longRespondStatus } =
    useContext(loaderContext);
  useEffect(() => {
    handleSetLoading(isCategoryLoadig, category);
  }, [isCategoryLoadig]);
  return { isLoading, longRespondStatus };
};
